import { useScrollAnimation } from "../../hooks/useScrollAnimation";

const proofs = [
  {
    metric: "0",
    descriptor: "IT resources required",
    description:
      "No task force needed. Works alongside your CRM and sales process.",
  },
  {
    metric: "100%",
    descriptor: "rep-compatible",
    description:
      "Supports your distributor and rep networks — instead of displacing them.",
  },
  {
    metric: "<30",
    descriptor: "days to scored leads",
    description:
      "Point Veranda at a market and get ranked leads before your next quarterly review.",
  },
];

export const CredibilitySection = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      className="py-24 px-[5%] border-t border-[#1e1e1e]"
      data-testid="credibility-section"
    >
      <div className="max-w-content mx-auto">
        <div
          ref={headerRef}
          style={{
            opacity: headerVisible ? 1 : 0,
            transform: headerVisible ? "translateY(0)" : "translateY(30px)",
            transition: "opacity 0.7s ease-out, transform 0.7s ease-out",
          }}
        >
          <p className="text-[0.7rem] font-semibold tracking-[3px] uppercase text-[#6b7280] mb-6">
            industry native
          </p>
          <h2 className="text-[clamp(2rem,4vw,3rem)] font-medium tracking-[-0.5px] leading-[1.2] text-white mb-16 max-w-3xl">
            Purpose-built for building products companies.
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {proofs.map((proof, idx) => (
            <div
              key={idx}
              className="bg-[#141414] border border-[#1e1e1e] rounded-[12px] p-8 flex flex-col"
              data-testid={`credibility-card-${idx}`}
              style={{
                opacity: cardsVisible ? 1 : 0,
                transform: cardsVisible ? "translateY(0) scale(1)" : "translateY(20px) scale(0.98)",
                transition: `opacity 0.6s ease-out ${0.1 + idx * 0.12}s, transform 0.6s ease-out ${0.1 + idx * 0.12}s`,
              }}
            >
              {/* Big Metric */}
              <p className="text-[60px] font-bold text-white leading-none tracking-[-2px]">
                {proof.metric}
              </p>
              {/* Descriptor Label */}
              <p className="text-[14px] text-[#6b7280] mt-2 mb-6">
                {proof.descriptor}
              </p>
              {/* Body Copy */}
              <p className="text-[0.875rem] text-[#9ca3af] leading-relaxed mt-auto">
                {proof.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
